import axios from 'axios';
import * as types from '../mutation-types';

const state = {
  avail: [],
  reservation: false,
  inventoryType: null,
};

// getters
const getters = {
  avail: s => s.avail,
  reservationCreated: s => s.reservation,
  selectedInventoryType: s => s.inventoryType,
};

// actions
const actions = {
  async loadRatesAndAvail({ commit }, { request }) {
    const availResponse = await axios.get('/api/availability/', {
      params: request,
    });

    const ratesResponse = await axios.post('/api/rate-prices/', request);

    commit(types.MUTATE_RATES_AND_AVAIL, {
      rates: ratesResponse.data,
      avail: availResponse.data,
    });
  },
};

// mutations
const mutations = {
  [types.MUTATE_RATES_AND_AVAIL](s, payload) {
    s.rates = payload.rates;
    s.avail = payload.avail;
  },
  mutateReservation(s, status) {
    s.reservation = status;
  },
  mutateInventoryType(s, id) {
    s.inventoryType = id;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
